import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAdminApi, errMsg, useSite } from "@/lib/site";
import { AdminTitle } from "./AdminMessages";
import { Field, inputCls } from "./AdminPackages";

const GROUPS = [
  ["Home — hero", [["hero_overline", "Small line above headline"], ["hero_title", "Headline"], ["hero_subtitle", "Intro text", 3], ["hero_image", "Hero image URL"], ["intro_statement", "Statement under hero", 2], ["ticker", "Scrolling ticker (comma separated)", 2]]],
  ["About page", [["about_title", "Headline"], ["about_body", "Story (blank line between paragraphs)", 6], ["about_image", "Image URL"]]],
  ["Call to action", [["cta_title", "Headline"], ["cta_body", "Text", 2]]],
  ["Contact details", [["phone", "Phone"], ["email", "Email"]]],
];

export default function AdminContent() {
  const call = useAdminApi();
  const { reload } = useSite();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { call("get", "/admin/content").then(setData).catch((e) => toast.error(errMsg(e))); }, [call]);
  const save = async () => {
    setBusy(true);
    try { setData(await call("put", "/admin/content", { data })); reload(); toast.success("Content saved — live on the site"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (!data) return <p className="text-slate-400">Loading…</p>;
  return (
    <div data-testid="admin-content">
      <AdminTitle sub="Text and images across the site">Content</AdminTitle>
      <div className="space-y-5">
        {GROUPS.map(([title, fields]) => (
          <div key={title} className="rounded-3xl bg-white border p-5 sm:p-6 space-y-3">
            <p className="font-display font-bold">{title}</p>
            {fields.map(([k, label, rows]) => (
              <Field key={k} label={label}>
                {rows ? <textarea rows={rows} className={inputCls} value={data[k] || ""} onChange={(e) => setData({ ...data, [k]: e.target.value })} data-testid={`admin-content-${k}`} />
                  : <input className={inputCls} value={data[k] || ""} onChange={(e) => setData({ ...data, [k]: e.target.value })} data-testid={`admin-content-${k}`} />}
                {k.endsWith("image") && data[k] && <img src={data[k]} alt="" className="mt-2 h-24 rounded-xl object-cover" />}
              </Field>
            ))}
          </div>
        ))}
      </div>
      <div className="sticky bottom-20 lg:bottom-4 mt-5 flex justify-end">
        <button onClick={save} disabled={busy} className="rounded-full bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 font-semibold shadow-lg disabled:opacity-60" data-testid="admin-content-save-btn">{busy ? "Saving…" : "Save content"}</button>
      </div>
    </div>
  );
}
